class ActionsBuilder {
    constructor() {
        this._actions = [];
    }
    addActions(...actions) {
        this._actions.push(...actions);
        return this;
    }
    addConditionalActions(condition, ...actions) {
        if (condition)
            this._actions.push(...actions);
        return this;
    }
    build() {
        const actions = [...this._actions];
        this._actions.length = 0;
        return actions;
    }
}
export default new ActionsBuilder();
